<template>
<div>
  <div class="levo__dole">
    <LevoHowTo text="How to play"  @leave="openModalHowTo" />
    <LevoLeave text="Sign out" @leave="signOut" />
    <ModalHowTo ref="modalRefHow" width="1120px">
      <div class="modal__questionHeader">
        Tutorials
      </div>
      <div class="clearfix questions">
      <div class="row">
        <a href="https://vimeo.com/664260402/40420ea88a" target="_blank">
          <div class="login__videos__video__button">
             Introduction to AdGame and data minimum
          </div>
        </a>
        <a href="https://vimeo.com/664260466/748d3d6904" target="_blank">
          <div class="login__videos__video__button">
             What is AdGame
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664261088/e8ff4278b0" target="_blank">
          <div class="login__videos__video__button">
             Registration and joining a game
          </div>
        </a>
        <a href="https://vimeo.com/664261114/59f83f689a" target="_blank">
          <div class="login__videos__video__button">
             How to play 
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664261179/9878514058" target="_blank">
          <div class="login__videos__video__button">
             Tips & tricks 
          </div>
        </a>
        <a href="https://vimeo.com/664261222/f69cdfb46b" target="_blank">
          <div class="login__videos__video__button">
             Scenarios (cities) 
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664261252/c65943c14b" target="_blank">
          <div class="login__videos__video__button">
             Starting the game as game owners
          </div>
        </a>
        <a href="https://vimeo.com/664261293/074e1c8cd3" target="_blank">
          <div class="login__videos__video__button">
             Game overview for game owners
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664261318/223d6e6e4a" target="_blank">
          <div class="login__videos__video__button">
             MS Excel: Creating a pivot table
          </div>
        </a>
        <a href="https://vimeo.com/664261406/90ed97006d" target="_blank">
          <div class="login__videos__video__button">
             MS Excel: Selection from pivot table
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664261519/1bcf803db0" target="_blank">
          <div class="login__videos__video__button">
             MS Excel: Visualization from pivot table
          </div>
        </a>
        <a href="https://vimeo.com/664261589/fdd30bad0b" target="_blank">
          <div class="login__videos__video__button">
             MS Excel: Processing large tables
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664260532/7b138eecef" target="_blank">
          <div class="login__videos__video__button">
             Dimensional modeling 
          </div>
        </a>
        <a href="https://vimeo.com/664260581/e2416a1ef8" target="_blank">
          <div class="login__videos__video__button">
             Introdution to PowerBI
          </div>
        </a>
        </div>
        <div class="row">
        <a href="https://vimeo.com/664260639/cf30937387" target="_blank">
          <div class="login__videos__video__button">
             PowerBI: Data transformation
          </div>
        </a>
        <a href="https://vimeo.com/664260891/009c8fd5ed" target="_blank">
          <div class="login__videos__video__button">
             PowerBI: Visualization and Dashboard
          </div>
        </a>
        </div>
      </div>
    </ModalHowTo>

  </div>
  </div>
</template>

<script>
import ModalHowTo from "@/components/general/ModalHowTo.vue";
import ModalHowtojs from "@/components/general/ModalHowTo.js";
import LevoLeave from "@/components/general/LevoLeave.vue";
import LevoHowTo from "@/components/general/LevoHowTo.vue";
import { mapActions } from "vuex";

export default {
  name: "LevoDole",
  mixins: [ModalHowtojs],
  components: {
    LevoLeave,
    LevoHowTo,
    ModalHowTo
  },
  methods: {
    ...mapActions({
      signOut: "signOut",
      toggleLoader: "toggleLoader",
    }),
  },
};
</script>
